import templateUrl from "emun.order/process-payment.htm";
import ProcessPaymentController from "emun.order/process-payment.controller";
import open from "webmodals/open";

let ProcessPayment = options => {
  let modalInstance = open({
    size: options.size || "xl",
    templateUrl: options.templateUrl || templateUrl,
	  controller: ProcessPaymentController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default ProcessPayment;
